<div class="banner"></div>
<div class="citation-panel-cover">
	<div class="col col-12 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10 citation-panel">
		<h2 class="d-print">{{clientName}}</h2>
		<h2 class="header-style" *ngIf="showingSearchResults">Outstanding Citations</h2>
		<div class="" style="margin: 0px" *ngIf="showingInvoice">
			<div class="">
				<h2 class="header-style">Invoice Order Details</h2>
			</div>
		</div>
		<div *ngIf="showingSearchResults">
			<div style="margin: 0px">
				<div class="row">
					<span class="col col-sm-12 col-md-6 col-lg-4 searching-for-text">Searching for:</span>                            
				</div>
				<div class="row">
					<div class="col col-12 col-sm-6 col-md-6 col-lg-4 offset-lg-2">
						<mat-card class="search-card scrollable-tooltip" matTooltip="Edit License Plate - Search Again" [routerLink]="['/search', { searchPlate: searchPlate, searchCitation: searchCitation }]">
							<mat-card-title class="box-text">License Plate</mat-card-title>
							<mat-card-subtitle>{{searchPlate}}</mat-card-subtitle>
						</mat-card>
					</div>
					<div class="col col-12 col-sm-6 col-md-6 col-lg-4">
						<mat-card class="search-card scrollable-tooltip" matTooltip="Edit Citation Number - Search Again" [routerLink]="['/search', { searchCitation: searchCitation, searchPlate: searchPlate }]">
							<mat-card-title class="box-text">Citation Number</mat-card-title>
							<mat-card-subtitle>{{searchCitation}}</mat-card-subtitle>
						</mat-card>
					</div>
				</div>
			</div>
			<div class="params-back-panel">
				<div class="text-center" *ngIf="searchResults === undefined || searchResults == null || searchResults.length == 0">
					<h3 *ngIf="!(searchResults === undefined || searchResults == null) && searchResults.length == 0">No outstanding citations found.</h3>
					<h3 *ngIf="searchResults === undefined || searchResults == null">Your request could not be completed. Please try again.</h3>
				</div>
				<div class="row" *ngIf="searchResults !== undefined && searchResults != null && searchResults.length > 0">
					<div class="col col-12">
						<h3>Here's what we found:</h3>
						{{searchResults[0].plateRegion}}

						<mat-table [dataSource]="searchResults" class="mat-elevation-z1">
							<!-- Select Column -->
							<ng-container matColumnDef="citationKey">
								<mat-header-cell *matHeaderCellDef><span class="d-none d-sm-inline">Select</span></mat-header-cell>
								<mat-cell *matCellDef="let element">
									<mat-checkbox *ngIf="element.amountDue > 0 && isPayable(element.statusId)" class="mat-table-checkbox" (change)="selectCitation(element, $event)" [checked]="isSelected(element.citationKey)" [disabled]="0 > element.amountDue || !isPayable(element.statusId)" matTooltip="{{isPayable(element.statusId) ? '' : 'This citation is not available to be paid here.'}}"></mat-checkbox>
									<mat-icon *ngIf="element.amountDue == 0 && isPayable(element.statusId)" matTooltip="PAID, CANCELLED, or WARNING - This citation is complete." style="color: #5cb85c;">done_all</mat-icon>
									<mat-icon *ngIf="!isPayable(element.statusId)" matTooltip="This citation is in Collections and may not be paid here.">launch</mat-icon>
								</mat-cell>
							</ng-container>

							<!-- Citation number Column -->
							<ng-container matColumnDef="citation">
								<mat-header-cell *matHeaderCellDef> Citation </mat-header-cell>
								<mat-cell *matCellDef="let element" class="scrollable-tooltip" matTooltip="{{element.description}}"> {{element.citationNumber}} </mat-cell>
							</ng-container>

							<!-- Description Column -->
							<ng-container matColumnDef="description">
								<mat-header-cell *matHeaderCellDef class="d-none d-md-flex"> Description </mat-header-cell>
								<mat-cell *matCellDef="let element" class="d-none d-md-flex"> {{element.description}} </mat-cell>
							</ng-container>

							<!-- Issued Date Column -->
							<ng-container matColumnDef="issued">
								<mat-header-cell *matHeaderCellDef class="d-none d-sm-flex"> Issued </mat-header-cell>
								<mat-cell *matCellDef="let element" class="d-none d-sm-flex"> {{element.issuedDate | date:'MMM d, y, h:mm a' }}
								</mat-cell>
							</ng-container>

							<!-- Amount Column -->
							<ng-container matColumnDef="amountDue">
								<th mat-header-cell *matHeaderCellDef> Amount </th>
								<td mat-cell *matCellDef="let element" class="text-right">
									<div matTooltip="Amount {{element.amount | currency}} Paid to date: {{element.amountPaid | currency}}">{{element.amountDue | currency}}</div>
								</td>
							</ng-container>

							<!-- Appeals Column -->
							<ng-container matColumnDef="appeals">
								<mat-header-cell *matHeaderCellDef class="d-none d-sm-flex align-center"> Appeal </mat-header-cell>
								<mat-cell *matCellDef="let element" class="d-none d-sm-flex">
									<a mat-button color="warn" [href]="appealsUrl + '/search-results;searchPlate=' + element.plate + ';searchCitation=' + element.citationNumber + ';searchKey=' + element.citationKey + '?clientKey=' + _clientService.getClientGuid()" *ngIf="element.canAppeal && !isInAppeals(element.statusId) && element.amountDue > 0 && appealsUrl" target="_blank" matTooltip="Would you like to open an appeal of this citation?">Open</a>
									<button mat-button color="primary" *ngIf="!element.canAppeal && element.amountDue > 0  || !appealsUrl" matTooltip="This citation cannot be appealed." [disabled]="true">Unavailable</button>
								</mat-cell>
							</ng-container>

							<mat-header-row *matHeaderRowDef="citationSearchTableColumns"></mat-header-row>
							<mat-row *matRowDef="let row; columns: citationSearchTableColumns;"></mat-row>
						</mat-table>
					</div>
				</div>
				<div class="row" style="padding-top: 30px;" *ngIf="selectedItems !== undefined && selectedItems != null && selectedItems.length > 0">
					<div class="col col-sm-10 col-md-8 offset-sm-1 offset-md-4">
						<mat-card class="summary-card">
							<mat-card-content>
								<mat-card-title>Summary</mat-card-title>
								<table class="table table-striped">
									<tr>
										<td> Items:</td>
										<td class="text-right">
											{{selectedItems.length}}
										</td>
									</tr>
									<tr>
										<td><label style="font-weight: bold;">Total</label>:</td>
										<td class="text-right">
											<label style="font-weight: bold;">$ {{totalAmountDue | number:'1.2-2'}}</label>
										</td>
									</tr>
								</table>
							</mat-card-content>
							<mat-card-actions class="payment-continue-actions">
								<button mat-raised-button class="payment-continue-button" [disabled]="0 > totalAmountDue" (click)="trackSearchKey(); createOrder();">Continue</button>
							</mat-card-actions>
						</mat-card>
					</div>
				</div>
				<div class="row" style="padding-top: 30px;">
					<div class="col col-12">
						<button mat-raised-button class="search-again-button" [routerLink]="['/search', { searchPlate: searchPlate, searchCitation: searchCitation }]"><i class="fa fa-chevron-left" aria-hidden="true"></i> <span>Search Again</span></button>
					</div>
				</div>
			</div>
		</div>
		<div class="results-back-panel" *ngIf="showingInvoice">
			<div class="row">
				<div class="col col-12">
					<div class="panel panel-info">
						<div class="panel-heading">
							<h3 class="panel-heading-h3">{{orderRefNumber}}</h3>
						</div>
						<div class="panel-body">
							<div class="row">
								<div class="col col-12 col-sm-6">
									<div class="row" *ngFor="let tax of activeTaxRates">
										<div class="col col-12" *ngIf="tax.number !== undefined && tax.number != null && tax.number.trim() != ''">
											<div class="text-left small">
												{{tax.number}}
											</div>
										</div>
									</div>
								</div>
								<div class="col col-12  col-sm-6 text-right">
									<span class="hidden-xs">Invoice Date:</span> {{activeOrder.orderDate | date:'MMM d, y, h:mm a'}} <small class="hint-date-time">(UTC)</small>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col col-lg-12">
					<div class="invoice-table">
						<mat-table [dataSource]="selectedItems" class="mat-elevation-z8">
							<!-- Item number Column -->
							<ng-container matColumnDef="citation">
								<mat-header-cell *matHeaderCellDef> Item </mat-header-cell>
								<mat-cell *matCellDef="let element"> {{element.citationNumber}} </mat-cell>
								<mat-footer-cell *matFooterCellDef style="font-weight: bold;"> Total </mat-footer-cell>
							</ng-container>

							<!-- Description Column -->
							<ng-container matColumnDef="description">
								<mat-header-cell *matHeaderCellDef class="d-none d-sm-flex"> Description </mat-header-cell>
								<mat-cell *matCellDef="let element" class="d-none d-sm-flex">
									<span> {{element.description}} </span>
									<div style="display: inline; margin-right: 10px;" *ngIf="showingReceipt">
										<mat-chip-set>
											<mat-chip [ngClass]="{ 'success-badge': isPaid(activeOrder.orderStatusId) || isAccepted(activeOrder.orderStatusId), 'danger-badge': isCancelled(activeOrder.orderStatusId) || isFailed(activeOrder.orderStatusId), 'warning-badge' : isPending(activeOrder.orderStatusId) }" style="margin-right: 10px;">
												<span style="padding: 10px;" *ngIf="isPaid(activeOrder.orderStatusId)">PAID</span>
												<span style="padding: 10px;" *ngIf="isAccepted(activeOrder.orderStatusId)">PARTIAL PAYMENT ACCEPTED</span>
												<span style="padding: 10px;" *ngIf="isCancelled(activeOrder.orderStatusId)">OUTSTANDING</span>
												<span style="padding: 10px;" *ngIf="isFailed(activeOrder.orderStatusId)">OUTSTANDING</span>
												<span style="padding: 10px;" *ngIf="isPending(activeOrder.orderStatusId)">PENDING</span>
												<span style="padding: 10px;" *ngIf="isReversed(activeOrder.orderStatusId)">OUTSTANDING</span>
											</mat-chip>
										</mat-chip-set>
									</div>
								</mat-cell>
								<mat-footer-cell *matFooterCellDef> </mat-footer-cell>
							</ng-container>

							<!-- Amount Column -->
							<ng-container matColumnDef="amount">
								<th mat-header-cell *matHeaderCellDef class="text-right"> Amount </th>
								<td mat-cell *matCellDef="let element" class="text-right"> {{element.amountDue | currency}} </td>
								<td mat-footer-cell *matFooterCellDef class="text-right" style="font-weight: bold;"> {{ totalAmountDue | currency}} </td>
							</ng-container>

							<mat-header-row *matHeaderRowDef="citationInvoiceTableColumns"></mat-header-row>
							<mat-row *matRowDef="let row; columns: citationInvoiceTableColumns;"></mat-row>
							<mat-footer-row *matFooterRowDef="citationInvoiceTableColumns"></mat-footer-row>
						</mat-table>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col col-12 order-3 order-md-1">
					<button mat-raised-button class="edit-items-button" (click)="showResults()" *ngIf="!showingReceipt && !useBatch">Edit Selected Items</button>
					<div class="d-print-none" *ngIf="showingReceipt">
						<button mat-raised-button class="search-again-button" [routerLink]="['/search', { searchPlate: searchPlate, searchCitation: searchCitation }]">Search Again</button>
					</div>
				</div>
				<div class="col col-md-5 offset-md-1 order-1 order-md-2" *ngIf="showingReceipt">
					<div class="text-left payment-accepted" >
						<mat-card class="summary-card">
							<h2 *ngIf="isPaid(activeOrder.orderStatusId) || isAccepted(activeOrder.orderStatusId)">
							Payment Accepted!</h2>
							<h2 *ngIf="isCancelled(activeOrder.orderStatusId)">Processing Cancelled!</h2>
							<h2 *ngIf="isFailed(activeOrder.orderStatusId)">Payment Declined!</h2>
							<div [innerHTML]="invoiceMessages"></div>
							<div style="margin-top: 30px" class="small">
								<mat-chip-set>
									<mat-chip [ngClass]="{ 'success-badge': isPaid(activeOrder.orderStatusId), 'danger-badge': isCancelled(activeOrder.orderStatusId) || isFailed(activeOrder.orderStatusId), 'warning-badge' : isPending(activeOrder.orderStatusId) }" style="margin-right: 10px;">
										<span style="padding: 10px;" *ngIf="isPaid(activeOrder.orderStatusId)">PAID</span>
										<span style="padding: 10px;" *ngIf="isAccepted(activeOrder.orderStatusId)">ACCEPTED</span>
										<span style="padding: 10px;" *ngIf="isCancelled(activeOrder.orderStatusId)">CANCELLED</span>
										<span style="padding: 10px;" *ngIf="isFailed(activeOrder.orderStatusId)">DECLINED</span>
										<span style="padding: 10px;" *ngIf="isPending(activeOrder.orderStatusId)">PENDING</span>
										<span style="padding: 10px;" *ngIf="isReversed(activeOrder.orderStatusId)">REVERSED</span>
									</mat-chip>
								</mat-chip-set>
								{{activeOrder.paidDate | date:'MMM d, y, h:mm a'}}
							</div>
						</mat-card>
					</div>
				</div>
				<div class="col col-md-5 order-2 order-md-3" [ngClass]="{'offset-md-6': !showingReceipt}">
					<div class="payment-summary">
						<mat-card class="summary-card">
							<mat-card-header>
								<mat-card-title>Payment Summary</mat-card-title>
							</mat-card-header>
							<mat-card-content>
								<table class="table table-striped">
									<tr *ngFor="let tax of activeTaxRates">
										<td class="text-right">
											<span>{{tax.name}}</span><span class="small">({{tax.rate * 100 | number : '1.1-2'}}%)</span>
										</td>
										<td class="text-right" style="padding-right: 20px;">
											$ {{tax.amount | number:'1.2-2'}}
										</td>
									</tr>
									<tr *ngIf="false">
										<td class="text-right">
											<span>Taxes</span>
										</td>
										<td class="text-right" style="padding-right: 20px;">
											<span>$ {{totalTaxesDue | number:'1.2-2'}}</span>
										</td>
									</tr>
									<tr>
										<td class="">
											<h2>Total</h2>
										</td>
										<td class="text-right" style="padding-right: 20px;"><h3>{{totalAmountDueInclTax | currency}}</h3></td>
									</tr>
									<tr *ngIf="showingReceipt">
										<td class="">
											<h2>Paid</h2>
										</td>
										<td class="text-right" style="padding-right: 20px;">
											<h3>{{activeOrder.paidAmount | currency}}</h3>
										</td>
									</tr>
								</table>
							</mat-card-content>
							<mat-card-actions>
								<div class="d-print-none payment-accept-actions" *ngIf="!showingReceipt && (clientPaymentProfile.solutionTypeId === undefined || clientPaymentProfile.solutionTypeId == null || clientPaymentProfile.solutionTypeId == solutionTypeEnum.Default || clientPaymentProfile.solutionTypeId == solutionTypeEnum.Hosted)">
									<form method="{{formSubmitMethod}}" [action]="clientPaymentProfile.processorUrl" ngNoForm>
										<input type="hidden" [name]="param.name" [value]="param.value" *ngFor="let param of clientPaymentProfile.params" />
										<button mat-raised-button class="full-width" type="submit" [ngClass]="{ 'mat-button-disabled': !cardProcessorAvailable, 'payment-accept-button': cardProcessorAvailable }" [disabled]="!cardProcessorAvailable">{{ cardProcessorAvailable == null ? 'Loading...' : (cardProcessorAvailable ? 'Accept' : 'Unavailable')}}</button>
									</form>
								</div>
								<div class="d-print-none" style="margin-top: 30px;" *ngIf="!showingReceipt && (clientPaymentProfile.solutionTypeId == solutionTypeEnum.iFrame || clientPaymentProfile.solutionTypeId == solutionTypeEnum.FullPage)">
									<button mat-raised-button color="primary" class="full-width payment-accept-button" type="submit" *ngIf="cardProcessorAvailable == true" [disabled]="isProcessing" (click)="openFramedPaymentModal();" matTooltip="Proceed to card processor.">{{cardProcessorAvailable ? 'Accept and Pay' : 'Unavailable'}}</button>
								</div>
							</mat-card-actions>
						</mat-card>
					</div>
				</div>
			</div>
			<div class="row d-print-none" style="margin: 30px 0" *ngIf="showingReceipt">
				<div class="col col-12 col-sm-10 col-sm-offset-1 col-lg-8 col-lg-offset-2">
					<p>Please print or bookmark this page for your own records.</p>
					<button mat-raised-button class="print-button" (click)="printPage();"><mat-icon>print</mat-icon> Print</button>
				</div>
			</div>
		</div>
	</div>
</div>
